<template>
  <app-view-template-secondary class="app-view-default-template-the-technology" title="<span class='color-black'>LoyalTfacts</span><span class='reserved-icon'></span>" :brands="brandsText">

      <!-- Section -->
      <app-section-default-template>
        <app-content-title label="The global enabler – LoyalTfacts<span class='reserved-icon'></span>"></app-content-title>

        <p>
          LoyalTfacts&reg; is our proprietary global SaaS end-to-end platform used by some of the largest and most respected
          loyalty programs around the world.
        </p>

        <p>
          LoyalTfacts&reg; is already connected to every cardholder on the planet and to every store or webshop, its one stop shopping for you.
        </p>

        <p>
          Below are a few highlights, please
          <a :href="getRoutePath('Contact')" v-on:click.prevent="onButtonClick('Contact')">contact us</a>
          for a demonstration of the extensive capabilities.
        </p>

        <ul>
          <li>Modular and scalable SaaS platform.</li>
          <li>Complete end-to-end solution for merchant funded programs.</li>
          <li>No IT projects needed – it can work as standalone solution.</li>
          <li>Easy integration to your existing systems if needed.</li>
          <li>PCI DSS level 1 certified and GDPR “store on soil” compliant.</li>
          <li>ISO27001 ,27017,27018 certified</li>
          <li>Real-time integrated to Visa, American Express, Mastercard and several domestic schemes.</li>
          <li>Open banking certified.</li>
          <li>Advanced real-time campaigns functionality.</li>
          <li>All customer facing interfaces available.</li>
          <li>Granular proprietary transactional data for customers.</li>
          <li>Lauded by customers for user friendliness.</li>
          <li>All data owned by our clients.</li>
        </ul>
      </app-section-default-template>

      <app-section-default-template>

        <div class="row">
          <div class="items-wrapper">

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.visa-global-enabler-modal class="item-inner visa-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/visa.png" alt="VISA icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.mc-global-enabler-modal class="item-inner mc-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/mastercard.png" alt="Mastercard icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.ax-global-enabler-modal class="item-inner ax-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/amex.png" alt="Amex icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.up-global-enabler-modal class="item-inner unionpay-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/unionpay.png" alt="Unionpay icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.dankort-global-enabler-modal class="item-inner dankort-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/dankort.png" alt="Dankort icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.bank-axept-global-enabler-modal class="item-inner bank-axept-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/bank-axept.png" alt="Bank Axept icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.eftpos-global-enabler-modal class="item-inner eftpos-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/eftpos.png" alt="Eftpos icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Card linking</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.ai-modules-global-enabler-modal class="item-inner ai-modules-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/ai-modules.png" alt="Ai modules icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>AI modules</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.design-global-enabler-modal class="item-inner program-design-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/program-design.png" alt="Design icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>The Program Design</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.api-global-enabler-modal class="item-inner api-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/api.png" alt="API icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Open Banking api</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.crm-global-enabler-modal class="item-inner crm-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/crm.png" alt="CRM icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Integration to CRM and ERP systems</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.app-global-enabler-modal class="item-inner app-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/app.png" alt="App icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Member App</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.member-pages-global-enabler-modal class="item-inner pages-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/member-page.png" alt="Member pages icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Member Pages</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.txn-global-enabler-modal class="item-inner data-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/txn.png" alt="Data icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Transactional data</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.merchant-global-enabler-modal class="item-inner merchant-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/merchant.png" alt="Merchant icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Partner Portal</strong></h6>
                </div>
              </a>
            </div>

            <div class="item-outer" v-vpshow>
              <a href="#" v-on:click.prevent="" v-b-modal.sign-up-global-enabler-modal class="item-inner sign-up-color">
                <div class="icon-wrapper">
                  <img src="@/assets/images/technology/app.png" alt="Sign up App icon">
                </div>

                <div class="label-wrapper">
                  <h6><strong>Sign up App</strong></h6>
                </div>
              </a>
            </div>
          </div>
        </div>

      </app-section-default-template>

      <!-- Section -->
      <app-section-default-template>
        <div class="button-wrapper">
          <app-button-primary :text="'Let\'s talk'" v-on:click.native="onButtonClick('Contact')"></app-button-primary>
        </div>
      </app-section-default-template>

      <app-modal-global-enabler title="Visa Card Linking" modalId="visa" headerClasses="visa-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to Visa, enabling you to add a card-linking option to your program in 3-4 weeks.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, GDPR checks, Visa security and compliance clearing, integrations etc. For you, it's “plug and play”.
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across the globe.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="Mastercard Card Linking" modalId="mc" headerClasses="mc-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to Mastercard  enabling you to add a Mastercard card-linking option to your program.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, GDPR checks, Mastercard security and compliance clearing, integrations etc. For you, it's “plug and play”.
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across the globe.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="American Express Card Linking" modalId="ax" headerClasses="ax-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to American Express, enabling you to add a card-linking option to your program.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, GDPR checks, American Express security and compliance clearing, integrations etc. For you, it's “plug and play”.
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across the globe.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="UnionPay Card Linking" modalId="up" headerClasses="unionpay-color">
        <p>
          In the pipeline, check back later or give us a call
        </p>
      </app-modal-global-enabler>
      
      <app-modal-global-enabler title="Dankort Card Linking" modalId="dankort" headerClasses="dankort-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to the Danish domestic payment scheme, Dankort, enabling you to add a Dankort card-linking option to your program. 
          Dankort is the largest card-scheme in Denmark.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, GDPR checks, integrations etc. For you, it's “plug and play”. 
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across Denmark.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="BankAxept Card Linking" modalId="bank-axept" headerClasses="bank-axept-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to the Norwegian domestic payment scheme, BankAxept, enabling you to add a BankAxept payment-linking option to your program. 
          BankAxept is the largest payment-scheme in Norway.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, GDPR checks, integrations etc. For you, it's “plug and play”. 
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across Norway.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="Eftpos Card Linking" modalId="eftpos" headerClasses="eftpos-color">
        <p>
          LoyalTfacts&reg; is <strong>real-time</strong> connected to the Australian domestic payment scheme and processor Eftpos, enabling you to add a Eftpos payment-linking option to your loyalty program. 
          Eftpos is one of the leading card-schemes in Australia.<br><br>

          We have already done all the heavy lifting, PCI DSS requirements, Data Privacy checks, integrations etc. For you, it's “plug and play”. 
          Your members can earn and/or redeem rewards at any merchant, in-store or online, across Australia.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="AI Modules" modalId="ai-modules" headerClasses="ai-modules-color">
        <p>
          Meet MIDAS&reg; and TIMM&reg; 2 modules that makes managing a large program so much easier. 
          7 Years of knowhow is incorporate in these two LoyalTfacts modules both available as an add on to LoyalTfacts.
        </p>
      </app-modal-global-enabler>

      <app-modal-global-enabler title="The Program Design" modalId="design" headerClasses="program-design-color">
        <p>
          <strong>Always start your process with defining the user experience.</strong><br>
          This may seem evident, but in too many cases, we have seen it is not adhered to. 
          This is the core for your program to be successful.<br><br>

          – next step - <br><br>

          <strong>Lean on our experience for your program design.</strong><br>
          We will apply best practice in strategy, implementation, and operation to the development of your program design. 
          We always take an outside-in approach, and we will facilitate the process for your teams and 
          develop the design together
        </p>
      </app-modal-global-enabler>

    <app-modal-global-enabler title="Open banking API" modalId="api" headerClasses="api-color">
      <p>
        We are approved as AISP under the EU PSD2 directive and under supervision of the Danish Financial Authority.<br><br>
        This enables us to access relevant information from any account in any EU bank when operating your program.<br><br>
        Naturally requiring the customers consent prior to connecting.<br><br>
        This opens additional possibilities in combination with one or more card linking options and other solutions.
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Integration to CRM and ERP systems" modalId="crm" headerClasses="crm-color">
      <p>
        LoyalTfacts&reg; will integrate easily to your current CRM assuring no adverse impact on your current processes,
        only additional transactional data and additional functionalities and options.<br><br>

        We have a full range of APIs and will adapt to your systems, minimizing any integration cost at your end.
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Member App" modalId="app" headerClasses="app-color">
      <p>
        You must have an App or responsive website with an optimal UX for a successful program. We offer skinned apps,
        responsive sites, SDKs, APIS and as always adapt the solution at our end to your current solutions and processes.<br><br>

        We will apply learnings and best practices to your design.
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Member Pages" modalId="member-pages" headerClasses="pages-color">
      <p>
        Whether in-App, online or both - you need a secure and well designed “My Page” for customers where they can
        manage preferences, manages cards, see rewards, redemptions, special offers etc. <br><br>

        We have a complete white label solution available for your design team to “color”.<br><br>

        We can also integrate relevant APIs to your current program pages.
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Transactional Data" modalId="txn" headerClasses="data-color">
      <p>
        A true goldmine in your program. After 9-12 months you will have built a very valuable asset and
        have learned and will continue to learn exactly what keeps your customers engaged and loyal. <br><br>

        Data mining may be done in LoyalTfacts&reg;, or we can integrate to and/or deliver the data to your current BI solution in real-time or in batches. <br><br>

        Not much extra work – tons of extra data
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Partner Portal" modalId="merchant" headerClasses="merchant-color">
      <p>
        The daily point of contact for your merchant partners.<br><br>

        In our Partner Portal your merchant partners have a host of functions available for self-service and in real time. 
        From campaign management to invoice reconciliation all available 24/7/365 All data made available to your partners, is of course anonymized.<br><br>

        Also including real-time transaction overview, setting campaigns, downloading collateral, receiving, 
        and downloading invoices etc.<br><br>

        All access is controlled by you.
      </p>
    </app-modal-global-enabler>

    <app-modal-global-enabler title="Sign Up App" modalId="sign-up" headerClasses="sign-up-color">
      <p>
        Proprietary technology for signing merchants to your program.<br><br> Give us a call to learn more.
      </p>
    </app-modal-global-enabler>

  </app-view-template-secondary>
</template>

<script>
  import AppViewTemplateSecondary from '@/components/layout/templates/view/AppViewTemplateSecondary';
  import AppButtonPrimary from '@/components/ui/buttons/AppButtonPrimary';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';
  import AppSectionDefaultTemplate from '@/components/layout/templates/section/AppSectionTemplateDefault';

  // Mixin
  import {mixinRoutesHandler} from '@/mixins/routes-handler';

  // Models
  import AppModalGlobalEnabler from '@/components/ui/modals/ModalGlobalEnabler';

  export default {
    name: 'TheTechnology',

    mixins: [mixinRoutesHandler],

    components: {
      AppViewTemplateSecondary, AppButtonPrimary, AppContentTitle, AppSectionDefaultTemplate,
      AppModalGlobalEnabler,
    },

    data: function() {
      return {
        brands: {},
        brandsText: {
          title: '',
          items: [
            {
              label: 'Our technology is the enabler of a world class user experience.',
            },
          ],
        },
      }
    },

    methods: {
      onButtonClick(routeName) {
        this._mixinGoToRouteName(routeName);
      },

      getRoutePath(routeName) {
        return this._mixinGetRoutePath(routeName);
      },
    },
  }
</script>

<style lang="scss">
  .app-view-default-template-the-technology {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../assets/images/technology/technology.jpg");
      }
    }

    h1 {
      text-transform: none !important;
    }

    ul li {
      list-style: none;

      &:before {
        content: "-";
        font-weight: bold;
        display: inline-block;
        width: 16px;
        margin-left: -16px;
      }
    }

    .items-wrapper {
      width: calc(100% + 15px);
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;

      .item-outer {
        width: 300px;
        padding: 15px;

        .item-inner {
          width: 100%;
          height: 247px;

          &:hover, &:focus {
            opacity: 0.7;
          }

          &:hover, &:focus, &:visited, &:active {
            text-decoration: none;
          }

          &.visa-color {
            background-color: #22275f;
          }

          &.mc-color {
            background-color: #ea001b;
          }

          &.ax-color {
            background-color: #016fd0;
          }

          &.unionpay-color {
            background-color: #fe9700;
          }

          &.dankort-color {
            background-color: #22505F;
          }

          &.bank-axept-color {
            background-color: #1EC21B;
          }

          &.eftpos-color {
            background-color: #019ED0;
          }

          &.ai-modules-color {
            background-color: #C01ACE;
          }

          &.program-design-color {
            background-color: #00bbd3;
          }

          &.api-color {
            background-color: #fec006;
          }

          &.crm-color {
            background-color: #6639b6;
          }

          &.app-color {
            background-color: #009587;
          }

          &.pages-color {
            background-color: #f34235;
          }

          &.data-color {
            background-color: #2095f2;
          }

          &.merchant-color {
            background-color: #8ac249;
          }

          &.sign-up-color {
            background-color: #fe5621;
          }

          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          .icon-wrapper {
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
          }

          .label-wrapper {
            width: 100%;
            color: white;
            text-transform: uppercase;
            margin-top: auto;
            padding-bottom: 10px;
            text-align: center;

            h6 {
              font-size: 15px;
              font-family: "proxima-nova-black", sans-serif;
              padding-inline: 21px;
            }
          }
        }
      }
    }

    .button-wrapper {
      margin-top: 60px;
      display: flex;
      justify-content: center;
    }

    .brands-wrapper {
      margin-bottom: 30px;
    }

    .schemes-section {
      h6 {
        text-align: center;
        font-weight: bold;
      }

      .schemes-wrapper {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        img {
          padding: 4px;
        }
      }
    }

    @media (min-width: $lgBreakpoint) {
      .items-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .item-outer {
          width: 25%;
          padding: 15px;
        }
      }

    }
  }
</style>
